import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'UIComponents/elements/headings';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import WebhookDefinitionEditPanelPropertiesTable from 'automation-ui-enrollment/components/eventEnrollment/WebhookDefinitionEditPanelPropertiesTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WebhookDefinitionEditPanelContents = ({
  webhookDefinition,
  stagedWebhookDefinition,
  setStagedWebhookDefinition,
  setPropertyEditIndex,
  onSave,
  onClose
}) => {
  const hasEventName = stagedWebhookDefinition.label.length > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.title"
        })
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsxs(UIPanelSection, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.description"
        }), /*#__PURE__*/_jsx(UIFormControl, {
          required: true,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.eventName"
          }),
          validationMessage: !hasEventName && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.errors.eventName"
          }),
          error: !hasEventName,
          children: /*#__PURE__*/_jsx(UITextInput, {
            name: "webhook-trigger-name",
            value: stagedWebhookDefinition.label,
            onChange: ({
              target: {
                value
              }
            }) => setStagedWebhookDefinition(current => Object.assign({}, current, {
              label: value
            }))
          })
        }), /*#__PURE__*/_jsx(WebhookDefinitionEditPanelPropertiesTable, {
          currentEventProperties: webhookDefinition.eventProperties,
          stagedEventProperties: stagedWebhookDefinition.eventProperties,
          setPropertyEditIndex: setPropertyEditIndex
        })]
      })
    }), /*#__PURE__*/_jsxs(UIPanelFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: hasEventName,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.errors.eventName"
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: onSave,
          disabled: !hasEventName,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.updateEvent"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onClose,
        responsive: false,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.cancelButton"
        })
      })]
    })]
  });
};
export default WebhookDefinitionEditPanelContents;